var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMstest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 271 250",
    style: {
      enableBackground: "new 0 0 271 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E4651C;}\r\n\t.st1{fill:#89C22F;}\r\n\t.st2{fill:#3EABED;}\r\n\t.st3{fill:#F2C032;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60.4,
    className: "st0",
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    className: "st1",
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.4,
    y: 78,
    className: "st2",
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    y: 78,
    className: "st3",
    width: 72,
    height: 72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.8,249.2L8.2,201.3H7.8c0.4,7.1,0.7,13.8,0.7,20v27.9H0v-57.3h13.2l15.9,45.6h0.2l16.4-45.6H59v57.3h-9v-28.3 c0-2.8,0.1-6.6,0.2-11.1c0.1-4.6,0.3-7.3,0.4-8.3h-0.3l-17.2,47.8H24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.2,233.7c0,5.1-1.8,9.1-5.5,12c-3.7,2.9-8.8,4.4-15.3,4.4s-11.8-1-15.9-3v-8.9c2.6,1.2,5.4,2.2,8.3,2.9 c2.9,0.7,5.7,1.1,8.2,1.1c3.7,0,6.4-0.7,8.2-2.1c1.8-1.4,2.6-3.3,2.6-5.7c0-2.1-0.8-4-2.4-5.4s-5-3.3-10-5.3 c-5.2-2.1-8.9-4.5-11.1-7.3c-2.1-2.7-3.2-6-3.2-9.8c0-4.8,1.7-8.5,5.1-11.3c3.4-2.7,8-4.1,13.7-4.1c5.5,0,11,1.2,16.4,3.6l-3,7.6 c-5.1-2.1-9.6-3.2-13.6-3.2c-3,0-5.3,0.7-6.9,2s-2.4,3.1-2.4,5.2c0,1.5,0.3,2.8,0.9,3.8c0.6,1.1,1.7,2.1,3.1,3 c1.4,0.9,4,2.2,7.8,3.7c4.2,1.8,7.3,3.4,9.3,4.9c2,1.5,3.4,3.2,4.3,5.1S107.2,231.1,107.2,233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.1,249.2h-9.4v-49.3h-16.9v-8h43.1v8h-16.9V249.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.7,250c-6.7,0-12-2-15.8-5.9s-5.7-9.4-5.7-16.3c0-7.1,1.8-12.7,5.3-16.7c3.5-4.1,8.4-6.1,14.5-6.1 c5.7,0,10.2,1.7,13.6,5.2c3.3,3.5,5,8.3,5,14.4v5h-28.9c0.1,4.2,1.3,7.4,3.4,9.7c2.1,2.3,5.2,3.4,9.1,3.4c2.6,0,4.9-0.2,7.2-0.7 s4.6-1.3,7.1-2.4v7.5c-2.2,1.1-4.5,1.8-6.8,2.3C187.2,249.8,184.6,250,181.7,250z M180,212c-2.9,0-5.3,0.9-7,2.8 c-1.8,1.9-2.8,4.6-3.2,8.1h19.7c-0.1-3.6-0.9-6.3-2.6-8.1C185.2,213,182.9,212,180,212z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.1,236.9c0,4.2-1.5,7.5-4.6,9.7c-3.1,2.3-7.5,3.4-13.3,3.4c-5.8,0-10.4-0.9-13.9-2.6v-8c5.1,2.4,9.8,3.5,14.2,3.5 c5.7,0,8.5-1.7,8.5-5.1c0-1.1-0.3-2-0.9-2.7s-1.7-1.5-3.1-2.3c-1.4-0.8-3.4-1.7-6-2.7c-5-1.9-8.4-3.9-10.1-5.8 c-1.8-1.9-2.6-4.4-2.6-7.5c0-3.7,1.5-6.6,4.5-8.6c3-2.1,7.1-3.1,12.2-3.1c5.1,0,9.9,1,14.5,3.1l-3,6.9c-4.7-1.9-8.6-2.9-11.8-2.9 c-4.9,0-7.3,1.4-7.3,4.2c0,1.4,0.6,2.5,1.9,3.5c1.3,0.9,4,2.2,8.3,3.9c3.6,1.4,6.2,2.7,7.8,3.8s2.8,2.5,3.6,4 S238.1,234.8,238.1,236.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.2,242.6c2.2,0,4.5-0.4,6.7-1.1v6.9c-1,0.4-2.3,0.8-3.9,1.1c-1.6,0.3-3.3,0.5-5,0.5c-8.7,0-13.1-4.6-13.1-13.8v-23.4 H243v-4.1l6.4-3.4l3.1-9.2h5.7v9.6h12.4v7h-12.4V236c0,2.2,0.6,3.9,1.7,4.9C261,242,262.4,242.6,264.2,242.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMstest);
export default __webpack_public_path__ + "static/media/mstest.02647447326cc47d33a3fdcb40af4c52.svg";
export { ForwardRef as ReactComponent };